<template>
  <div class="form-group ">
    <input class="form-control" name="registerEmail" type="email" id="registerEmail" v-model="email" @blur="verifyEmail">
    <span class="af-icons af-icons-repeat af-icons-animate-rotate fetchingIcon" v-if="fetching"></span>
    <span class="af-icons af-icons-cross emailExistsIcon" v-if="showEmailExistsAlerts"></span>
    <div class="emailExistsText" v-if="showEmailExistsAlerts">{{ lang.get('home.register.user_with_email_exists') }}</div>
    <span class="af-icons af-icons-tick emailDoesNotExistIcon" v-if="email && emailDoesNotExist"></span>
    <div class="emailInvalid" v-if="!valid">{{ lang.get('home.register.invalid_email') }}</div>
  </div>
</template>

<script>
import $ from 'jQuery';
import langMixin from './../../../lib/components/Translations/mixins/lang-mixin.js';
import emailValidator from './../../../lib/components/Fields/validator/email.js';

export default {
  mixins: [langMixin],
  props: {
    email: {
      type: String,
      default: null
    }
  },
  data() {
    return {
      emailExists: false,
      emailDoesNotExist: false,
      fetching: false,
      valid: true
    };
  },
  watch: {
    email(newValue) {
      if (!newValue) {
        this.valid = true;
        this.emailExists = false;
        this.emailDoesNotExist = false;
        $('.form-actions input').prop('disabled', false);
      }
    }
  },
  methods: {
    verifyEmail() {
      // Only validate and verify email if present
      if (!!this.email) {
        // Disable register button
        $('.form-actions input').prop('disabled', true);

        this.valid = true;
        this.emailExists = false;
        this.emailDoesNotExist = false;

        // Validate email
        if (!emailValidator(this.email)) {
          this.valid = false;
          return;
        }

        this.fetching = true;

        // Verify email
        this.$http.post('/register/verify-email', {'email': this.email}).then((response) => {
          this.fetching = false;
          this.toggleAlert(response.data);
        });
      }
    },
    toggleAlert(emailExists) {
      if (emailExists) {
        this.emailExists = true;
      } else {
        this.emailDoesNotExist = true;
        if (!$(".mobileExistsText").is(':visible')) {
          $('.form-actions input').prop('disabled', false);
        }
      }
    }
  },
  computed: {
    showEmailExistsAlerts() {
      return this.email && this.emailExists;
    }
  }
};
</script>

<style scoped>
  .fetchingIcon, .emailExistsIcon, .emailDoesNotExistIcon {
    float: right;
    margin-right: 10px;
    margin-top: -27px;
    position: relative;
    z-index: 2;
    cursor: default;
  }

  .emailInvalid {
    color: #e0003f;
    margin-top: 5px;
  }

  .emailExistsIcon {
    color: #e0003f;
  }

  .emailExistsText {
    color: #e0003f;
    margin-top: 5px;
  }

  .emailDoesNotExistIcon {
    color: green;
  }
</style>
